import StockTabPanel from './StockTabPanel';

export default StockTabPanel;
